import React, { Component } from 'react'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { Row, Col, Modal, Table } from 'antd'
import { compose } from 'recompose'
// import moment from 'moment'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { visible, onCancel, importResults } = this.props

		const columns = [{
			title: 'Last Name',
			// dataIndex: 'household_no',
			key: 'last_name',
			render: (record) => {
				return <span>{record.data[9]}</span>
			}
		}, {
			title: 'Middle Name',
			// dataIndex: 'household_no',
			key: 'middle_name',
			render: (record) => {
				return <span>{record.data[11]}</span>
			}
		}, {
			title: 'First Name',
			// dataIndex: 'household_no',
			key: 'first_name',
			render: (record) => {
				return <span>{record.data[10]}</span>
			}
		}, {
			title: 'Household no',
			// dataIndex: 'household_no',
			key: 'household_no',
			render: (record) => {
				return <span>{record.data[0]}</span>
			}
		}, {
			title: 'Status',
			// dataIndex: 'household_no',
			key: 'status',
			render: (record) => {
				return <span>
					{
						(record.success) ? <span className={'badge badge-success'}>Success</span> : 
							<span className={'badge badge-danger'}>Failed</span> 
					}
				</span>
			}
		}, {
			title: 'Status message',
			// dataIndex: 'household_no',
			key: 'message',
			render: (record) => {
				return <span>{record.message}</span>
			}
		}]
		return (
			<Modal
				title='View Event Details'
				width='80%'
				visible={visible}
				onCancel={onCancel}
				destroyOnClose
				footer={null}
			>
				<Table 
					// loading={loading}
					columns={columns} 
					dataSource={importResults} 
					bordered
					// onChange={this.handleOnChange}
					// pagination={_pagination}
					scroll={{ x: 1020 }}
				/>
			</Modal>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)